import { jsx } from "react/jsx-runtime";
import { createSvgIcon } from "@mui/material";
const Arrow = createSvgIcon(
  /* @__PURE__ */ jsx("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8 8.67975L10.8227 5.85707C11.092 5.58774 11.5287 5.58774 11.798 5.85707C12.0673 6.12639 12.0673 6.56306 11.798 6.83239L8.48766 10.1427C8.21833 10.4121 7.78167 10.4121 7.51234 10.1427L4.202 6.83239C3.93267 6.56306 3.93267 6.12639 4.202 5.85707C4.47132 5.58774 4.90799 5.58774 5.17731 5.85707L8 8.67975Z",
      fill: "currentColor"
    }
  ) }),
  "Arrow"
);
export {
  Arrow as default
};
